module.exports = __webpack_public_path__ + "img/ic_search.83fdd99f.svg";